export const NO_GOV_CARD_COPY = {
  desc: 'Want to know when they join?',
};
